import React from 'react'
import { EmptyStateContainer, EmptyStateIcon } from './styles'

const SettingsEmptyState = ({
  icon,
  heading,
  description,
  actionLabel,
  onAction,
}) => (
  <EmptyStateContainer>
    {icon && <EmptyStateIcon>{icon}</EmptyStateIcon>}
    <h2 style={{ color: '#111827', marginBottom: '0.5rem' }}>{heading}</h2>
    {description && (
      <p style={{ color: '#6b7280', marginBottom: '1.5rem' }}>{description}</p>
    )}
    {actionLabel && onAction && (
      <button
        onClick={onAction}
        style={{
          color: '#2563eb',
          background: 'none',
          border: 'none',
          textDecoration: 'underline',
          cursor: 'pointer',
        }}
      >
        {actionLabel}
      </button>
    )}
  </EmptyStateContainer>
)

export default SettingsEmptyState
